import httpClient from '@shared/http/client';
import { clearResponseCache } from './cache';

export const patchSource = (url, object) =>
  new Promise(async resolve => {
    try {
      const response = await httpClient.patch(url, object);
      clearResponseCache(url);
      resolve({
        body: response.data,
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        ok: true,
      });
    } catch (err) {
      clearResponseCache(url);
      if (err.response) {
        resolve({
          body: err.response.data,
          status: err.response.status,
          statusText: err.response.statusText,
          headers: err.response.headers,
          ok: false,
        });
      } else {
        resolve(new Error(err.message));
      }
    }
  });
